module.exports = "/img/_/_/_/assets/images/payment_item//diamonds30.png?ac0fd1f04617cb474a4ce561acd0fe4d";